<template>
  <div class='DashBoard'>
    <iframe
    :src="'/dashboard/dash/template/DashCR.html?_id='+Empresa._id"
    width="100%" 
    height="100%"
    frameborder="0">
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DashBoard',
  computed: {
    ...mapGetters(['Empresa'])
  }
}
</script>

<style scoped>
.DashBoard {
  width: 100%;
  height: 100%;
}
</style>
